<template>
    <layout>
        <main role="main" class="background-employer-dashboard background-employer-dashboard-bottom pb-5">
            <div class="container">
                <nav aria-label="breadcrumb" class="mt-4">
                    <ol class="breadcrumb font-poppins font-weight-light font-size-14 color-blue px-0 bg-white">
                        <li class="breadcrumb-item">
                            <a
                                :href="route('nl.employerdashboard.employees.overview', $page.props.auth.user.selected_company.uuid)"
                                class="font-poppins font-weight-semibold color-blue">
                                {{ Lang.get('employerdashboard::pages/employee/breadcrumb.overview') }}</a>
                        </li>
                        <li class="breadcrumb-item color-blue" aria-current="page">
                            {{ Lang.get('employerdashboard::pages/employee/breadcrumb.profile') }}</li>
                    </ol>
                </nav>
                <h1 class="title font-poppins color-blue mt-4">{{ Lang.get('employerdashboard::pages/employee/profile.title', {fullname: employee.full_name}) }}</h1>
                <h6 class="font-poppins font-weight-light font-size-18 color-blue">{{ Lang.get('employerdashboard::pages/employee/profile.subtitle') }}</h6>
                <div class="row mt-3">
                    <div class="col-12 mb-4 px-0">
                        <div class="alert alert-warning" v-if="employee.is_anonymous">
                            <i class="fa fa-exclamation-circle pr-2"></i>
                            <template v-if="employee.is_disabled_from_participation">
                                {{ Lang.get('employerdashboard::shared.is_disabled_from_participation') }}
                            </template>
                            <template v-else>

                            </template>
                            <p class="pt-2 pl-4">
                                <strong>{{ Lang.get('employerdashboard::pages/employee/profile.explanation') }}:</strong><br />
                                <span>{{ employee.disabled_from_participation_reason }}</span>
                            </p>
                            <p class="pt-1 pl-4" v-html="Lang.get('employerdashboard::pages/employee/profile.disabled_from_participation.footer', {reference: employee.disabled_from_participation_reference})"></p>
                        </div>

                        <div class="alert alert-danger alert-danger-icon" v-if="!employee.has_email && !employee.is_disabled_from_participation && !$page.props.auth.isCompanyProviderManually">
                            <span>{{ Lang.get('employerdashboard::pages/employee/profile.has_no_emailaddress.description') }}</span>
                        </div>

                        <flash-messages :hide-errors="true"></flash-messages>

                        <div class="card border-radius-8 shadow">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-12 col-md-6 mb-4" v-if="!employee.is_anonymous">

                                        <h1 class="font-poppins font-weight-light color-blue mb-3">
                                            {{ Lang.get('employerdashboard::pages/employee/profile.widgets.person_information.title') }}</h1>
                                        <ul class="list-group employee-profile-list-group font-poppins font-weight-semibold color-blue">
                                            <inertia-link
                                                :href="route('nl.employerdashboard.employee.show', {
                                                                company_as_uuid: $page.props.auth.user.selected_company.uuid,
                                                                employee_uuid: employee.uuid
                                                                })" class="font-poppins color-dark-blue font-weight-medium no-underline">
                                                <li class="list-group-item d-flex justify-content-between align-items-center mb-3">
                                                <span>
                                                    <img src="/img/employer-dashboard/icons/eye.svg" class="pr-2">
                                                    {{ Lang.get('employerdashboard::pages/employee/profile.widgets.person_information.view') }}
                                                </span>
                                                    <img src="/img/employer-dashboard/icons/chevron-right.svg" class="float-right">
                                                </li>
                                            </inertia-link>

                                            <a
                                                href="#"
                                                class="font-poppins color-dark-blue font-weight-medium no-underline"
                                                data-toggle="modal" data-target="#cannotEditModal"
                                                v-if="employee.is_disabled_from_participation && $page.props.auth.isCompanyProviderManually || ($page.props.auth.isCompanyProviderManually && $page.props.auth.company_terminated.terminated)">
                                                <li class="list-group-item d-flex justify-content-between align-items-center mb-3">
                                                <span>
                                                    <img src="/img/employer-dashboard/icons/edit.svg" class="pr-2">
                                                    {{ Lang.get('employerdashboard::pages/employee/profile.widgets.person_information.edit') }}
                                                </span>
                                                    <img src="/img/employer-dashboard/icons/chevron-right.svg" class="float-right">
                                                </li>
                                            </a>

                                            <inertia-link
                                                v-if="!employee.is_anonymous && !employee.is_disabled_from_participation && $page.props.auth.isCompanyProviderManually && !$page.props.auth.company_terminated.terminated"
                                                :href="route('nl.employerdashboard.employee.edit', {
                                                                company_as_uuid: $page.props.auth.user.selected_company.uuid,
                                                                employee_uuid: employee.uuid
                                                                })" class="font-poppins color-dark-blue font-weight-medium no-underline">
                                                <li class="list-group-item d-flex justify-content-between align-items-center mb-3">
                                                <span>
                                                    <img src="/img/employer-dashboard/icons/edit.svg" class="pr-2">
                                                    {{ Lang.get('employerdashboard::pages/employee/profile.widgets.person_information.edit') }}
                                                </span>
                                                    <img src="/img/employer-dashboard/icons/chevron-right.svg" class="float-right">
                                                </li>
                                            </inertia-link>

                                            <a class="font-poppins color-dark-blue font-weight-medium no-underline"
                                               data-toggle="collapse"
                                               href="#addingAdditionalEmailAddressForm"
                                               role="button"
                                               aria-expanded="false"
                                               aria-controls="addingAdditionalEmailAddressForm"
                                               v-if="!employee.has_email && !employee.is_disabled_from_participation && !$page.props.auth.isCompanyProviderManually">
                                                <li class="list-group-item d-flex justify-content-between align-items-center mb-3">
                                                <span>
                                                    <img src="/img/employer-dashboard/icons/add-email.svg" class="pr-2">
                                                    {{ Lang.get('employerdashboard::pages/employee/profile.widgets.person_information.add_extra_email') }}
                                                </span>
                                                    <img src="/img/employer-dashboard/icons/chevron-right.svg" class="float-right">
                                                </li>
                                            </a>
                                        </ul>

                                        <div class="row" v-if="!employee.has_email">
                                            <div class="col">
                                                <div class="collapse multi-collapse"
                                                     :class="{show: errors.email_additional}"
                                                     id="addingAdditionalEmailAddressForm">
                                                    <div class="alert alert-default">
                                                        <h4><i class="fa fa-envelope pr-2"></i> {{ Lang.get('employerdashboard::pages/employee/profile.adding_email_additional_form.title') }}</h4>
                                                        <text-input
                                                            v-model="form.email_additional"
                                                            :placeholder="Lang.get('employerdashboard::shared.placeholder.emailaddress')"
                                                            :error="errors.email_additional"
                                                        />

                                                        <div class="form-row mt-3">
                                                            <div class="form-group col-12 col-md-4 col-lg-3">
                                                                <button class="btn btn-primary font-poppins font-weight-bold btn-orange border-radius-19 px-4" @click="saveAdditionalEmailAddress">{{ Lang.get('employerdashboard::shared.save') }}</button>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="col-12 col-md-6 mb-2">
                                        <h1 class="font-poppins font-weight-light color-blue mb-3">
                                            {{ Lang.get('employerdashboard::pages/employee/profile.widgets.finance.title') }}</h1>
                                        <ul class="list-group employee-profile-list-group font-poppins font-weight-semibold color-blue">
                                            <inertia-link :href="route('nl.employerdashboard.employee.transactions', {
                                                                company_as_uuid: $page.props.auth.user.selected_company.uuid,
                                                                employee_uuid: employee.uuid
                                                                })" class="font-poppins color-dark-blue font-weight-medium no-underline">
                                                <li class="list-group-item d-flex justify-content-between align-items-center mb-3">
                                                <span>
                                                    <img src="/img/employer-dashboard/icons/view-iob.svg" class="pr-2">
                                                    {{ Lang.get('employerdashboard::pages/employee/profile.widgets.finance.view_iob_calculation') }}
                                                </span>
                                                    <img src="/img/employer-dashboard/icons/chevron-right.svg" class="float-right">
                                                </li>
                                            </inertia-link>

                                            <inertia-link v-if="permissions.is_budget_deposit_page" :href="route('nl.employerdashboard.employee.deposits', {
                                                                company_as_uuid: $page.props.auth.user.selected_company.uuid,
                                                                employee_uuid: employee.uuid
                                                                })" class="font-poppins color-dark-blue font-weight-medium no-underline">
                                                <li class="list-group-item d-flex justify-content-between align-items-center mb-3">
                                                <span>
                                                    <img src="/img/employer-dashboard/icons/view-iob.svg" class="pr-2">
                                                    {{ Lang.get('employerdashboard::pages/employee/profile.widgets.finance.deposits') }}
                                                </span>
                                                    <img src="/img/employer-dashboard/icons/chevron-right.svg" class="float-right">
                                                </li>
                                            </inertia-link>
                                            <inertia-link v-if="permissions.is_manually_budget_deposit_enabled" :href="route('nl.employerdashboard.employee.create.budget.deposit', {
                                                                company_as_uuid: $page.props.auth.user.selected_company.uuid,
                                                                employee_uuid: employee.uuid
                                                                })" class="font-poppins color-dark-blue font-weight-medium no-underline">
                                                <li class="list-group-item d-flex justify-content-between align-items-center mb-3">
                                                <span>
                                                    <img src="/img/employer-dashboard/icons/view-iob.svg" class="pr-2">
                                                    {{ Lang.get('employerdashboard::pages/employee/profile.widgets.finance.create_budget_deposit') }}
                                                </span>
                                                    <img src="/img/employer-dashboard/icons/chevron-right.svg" class="float-right">
                                                </li>
                                            </inertia-link>
                                        </ul>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12 col-md-6 mb-4" v-if="employee.is_disabling_due_retirement_age_possible">
                                        <h1 class="font-poppins font-weight-light color-blue mb-3">
                                            {{ Lang.get('employerdashboard::pages/employee/profile.widgets.help_and_support.title') }}
                                        </h1>
                                        <ul class="list-group employee-profile-list-group font-poppins font-weight-semibold color-blue">
                                            <a class="font-poppins color-dark-blue font-weight-medium no-underline"
                                               data-toggle="collapse" href="#disablingFromParticipationPensionAgeInfo" role="button" aria-expanded="false" aria-controls="disablingFromParticipationPensionAgeInfo">
                                                <li class="list-group-item d-flex justify-content-between align-items-center mb-3">
                                                <span>
                                                    <img src="/img/employer-dashboard/icons/remove.svg" class="pr-2">
                                                    {{ Lang.get('employerdashboard::pages/employee/profile.widgets.help_and_support.disable_account_because_of_pension_date') }}
                                                </span>
                                                    <img src="/img/employer-dashboard/icons/chevron-right.svg" class="float-right">
                                                </li>
                                            </a>
                                        </ul>
                                    </div>
                                    <div class="col-12 collapse multi-collapse" id="disablingFromParticipationPensionAgeInfo">
                                        <div class="alert alert-info employee-profile-alert">
                                            <h4><i class="fa fa-exclamation-circle pr-2"></i> {{ Lang.get('employerdashboard::pages/employee/profile.disabling_from_participation.explanation.pension_age.title') }}</h4>
                                            <p class="pt-2 pl-4" v-html="Lang.get('employerdashboard::pages/employee/profile.disabling_from_participation.explanation.pension_age.description')"></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Cannot Edit Modal -->
                <div class="modal fade" id="cannotEditModal" tabindex="-1" role="dialog" aria-labelledby="cannotEditModalLabel" aria-hidden="true">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="cannotEditModalLabel">
                                    {{ Lang.get('employerdashboard::pages/employee/profile.widgets.person_information.edit_not_possible.title') }}</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <span v-if="$page.props.auth.company_terminated.terminated">
                                    {{ Lang.get('employerdashboard::pages/employee/profile.widgets.person_information.edit_not_possible.description_company_terminated') }}
                                </span>
                                <span v-else>
                                    {{ Lang.get('employerdashboard::pages/employee/profile.widgets.person_information.edit_not_possible.description') }}
                                </span>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ Lang.get('employerdashboard::pages/employee/profile.widgets.person_information.edit_not_possible.close') }}</button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </main>
    </layout>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from "@/Shared/TextInput";
import SelectInput from "@/Shared/SelectInput";
import FlashMessages from "@/Shared/FlashMessages";

export default {

    metaInfo() {
        return {
            title: `${this.Lang.get('employerdashboard::pages/employee/profile.title', {'fullname': this.employee.full_name})}`,
        }
    },
    components: {
        FlashMessages,
        SelectInput,
        TextInput,
        Layout,
    },
    props: {
        employee: Object,
        permissions: Object,
        errors: Object,
    },

    data() {
        return {
            form: {
                email_additional: null,
            }
        }
    },

    methods: {
        saveAdditionalEmailAddress() {
            this.$inertia.post(this.route('nl.employerdashboard.employee.save.additional.email.attempt', {
                company_as_uuid: this.$page.props.auth.user.selected_company.uuid,
                employee_uuid: this.employee.uuid
            }), this.form);
        },
    },
}
</script>
